const elem = document.querySelector('#dob');
const datepicker = new Datepicker(elem, {
  format: 'dd-mm-yyyy'
});

const countryData = "https://cdn.shopify.com/s/files/1/0648/0514/2781/files/country_code_and_details.json";

fetch(countryData)
  .then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }
    return response.json();
  })
  .then((data) => {
    while (document.getElementById("country-code").options.length > 0) {
      document.getElementById("country-code").remove(0);
    }

    const countries = data.countries || [];
    const selectBox = document.getElementById("country-code");

    countries.forEach((country) => {
      const option = document.createElement("option");
      option.value = `+${country.phone_code}`;
      option.textContent = `${country.country_code} (+${country.phone_code})`;

      if (country.country_code === "IN") {
        option.selected = true;
      }

      selectBox.appendChild(option);
    });
  })
  .catch((error) => {
    console.error("Error fetching JSON data:", error);
  });

let map;
let manager;
let lat = "22.572645",
  longs = "88.363892",
  locationOn = false,
  selectedLoc;

function renderProducts(products) {
  const productListContainer = document.getElementById("productList");
  productListContainer.innerHTML = "";

  if (products.length === 1) {
    // If there is only one product
    const product = products[0];
    productListContainer.innerHTML = `
        <div class="product-item">
          <div class="product-item-image">
            <img src="${product.image}" alt="${product.name}" class="product-image" />
          </div>
          <h3>${product.name}</h3>
          <button class="product-link" onclick="window.open('${product.url}', '_blank')">Buy Now</button>
        </div>
      `;
  } else if (products.length === 2) {
    // If there are exactly two products, add "or" in between
    const productItemsHTML = products
      .map(
        (product, index) => `
          <div class="product-item">
            <div class="product-item-image">
              <img src="${product.image}" alt="${product.name}" class="product-image" />
            </div>
            <h3>${product.name}</h3>
            <button class="product-link" onclick="window.open('${product.url}', '_blank')">Buy Now</button>
          </div>
          ${index === 0 ? '<div class="multiple">OR</div>' : ""}
        `
      )
      .join("");

    productListContainer.innerHTML = productItemsHTML;
  } else {
    const productItemsHTML = products
      .map(
        (product) => `
          <div class="product-item">
            <div class="product-item-image">
              <img src="${product.image}" alt="${product.name}" class="product-image" />
            </div>
            <h3>${product.name}</h3>
            <button class="product-link" onclick="window.open('${product.url}', '_blank')">Buy Now</button>
          </div>
        `
      )
      .join("");

    productListContainer.innerHTML = `
        ${productItemsHTML}
        <div class="existing">Existing</div>
      `;
  }

  document.querySelector(".product-list-wrapper").style.display = "block";
  document.querySelector(".rudraksh-banner-container").style.display = "flex";
  document.getElementById("loader").style.display = "none";
}

function selectedSuggestion(suggestionResult) {
  if (!manager) return;

  lat = suggestionResult?.location?.latitude;
  longs = suggestionResult?.location?.longitude;
  selectedLoc = suggestionResult?.formattedSuggestion;
  locationOn = true;
}

const displaySuggestions = (suggestions) => {
  const suggestionsList = document.getElementById("suggestions");
  suggestionsList.innerHTML = "";
  suggestions.forEach((suggestion) => {
    const listItem = document.createElement("li");
    listItem.textContent = `${suggestion.address}`;
    listItem.setAttribute("lat", suggestion.coordinates[0]);
    listItem.setAttribute("lon", suggestion.coordinates[1]);
    listItem.addEventListener("click", function () {
      const s_box = document.getElementById("searchBox");
      s_box.value = suggestion.address;
      s_box.setAttribute("lat", suggestion.coordinates[0]);
      s_box.setAttribute("lon", suggestion.coordinates[1]);
      console.log(suggestion);
      s_box.setAttribute("selected", suggestion.address);
      document.getElementById("suggestions").innerHTML = "";
    });
    listItem.style.cursor = "pointer";
    suggestionsList.appendChild(listItem);
  });
};

const primaryKey = "ubcsy6zDJKyVgIsyHOU3cDJsIIJq4c6AaxWUyZlZD325czV845OAJQQJ99AKACYeBjFqAWCNAAAgAZMP3A5E";

document.getElementById("searchBox").addEventListener("input", function (event) {
  const fetchSuggestions = async () => {
    var mapValue = document.getElementById("searchBox").value;
    if(mapValue.length > 3) {
      try {
        // const response = await fetch(`https://atlas.microsoft.com/search/address/json?api-version=1.0&query=${document.getElementById("searchBox").value}&subscription-key=${primaryKey}`);
        // const response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${document.getElementById("searchBox").value}.json?access_token=pk.eyJ1IjoidGVjaGFzdHJvYXJ1biIsImEiOiJjbTd2dHYwbDQwMDBvMmpyMTAweW9rMGFrIn0.S3g_9l651onCSCGNVvbtXw&autocomplete=true&types=place`);
        const response = await fetch(`https://api.mapbox.com/search/geocode/v6/forward?q=${document.getElementById("searchBox").value}&proximity=ip&access_token=pk.eyJ1IjoidGVjaGFzdHJvYXJ1biIsImEiOiJjbTd2dHYwbDQwMDBvMmpyMTAweW9rMGFrIn0.S3g_9l651onCSCGNVvbtXw`);
        if (!response.ok) {
          throw new Error("Failed to fetch suggestions");
        }
        const data = await response.json();
        console.log(data.features);
        const suggestions = data.features.map((result) => ({
          address: result.properties.full_address,
          coordinates: [result.properties.coordinates.latitude, result.properties.coordinates.longitude],
        }));
        console.log(suggestions);
        displaySuggestions(suggestions);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    }
  };

  fetchSuggestions();
});

document.getElementById("astrologyForm").addEventListener("submit", function (event) {
  event.preventDefault();

  const nameInput = document.getElementById("full_name").value.trim();
  if (nameInput === "") {
    alert("Name is required.");
    return;
  }

  if (nameInput.length < 3) {
    alert("Please Enter Valid Name");
    return;
  }

  const namePattern = /^[a-zA-Z\s'-]+$/;
  if (!namePattern.test(nameInput)) {
    alert("Name contains invalid characters.");
    return;
  }

  // const emailInput = document.getElementById("email").value;
  // console.log(emailInput);
  // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // if(emailRegex.test(email)) {
  //   alert("Please Enter a valide E-Mail address");
  //   return;
  // }

  const dateInput = document.getElementById("dob").value;
  const invalidYearRegex = /^0\d{3}-\d{2}-\d{2}$/;
  if (invalidYearRegex.test(dateInput)) {
    alert("Please enter a valid date");
    return;
  }

  if (document.getElementById("searchBox").getAttribute("selected") != document.getElementById("searchBox").value) {
    // console.log(document.getElementById("searchBox").getAttribute("selected"), document.getElementById("searchBox").value)
    alert("Please fill correct location");
    return;
  }

  document.getElementById("loader").style.display = "block";

  let map;

  const selectedPurpose = document.getElementById("purpose").value;
  const searchBox = document.getElementById("searchBox");

  const formData = new FormData(this);

  const apiEndpoint = "https://api.astroarunpandit.org/verified-rudraksha-info";
  const apiKey = "PWVN7FhSdp1mRbokpRbwl7sl9NBk9vkO40ki8UJK";
  var birthDate = formData.get("dob");
  let dateArr = birthDate.split("-");
  let formattedDate = `${dateArr[2]}/${dateArr[1]}/${dateArr[0]}`;
  const urlParams = new URLSearchParams({
    full_name: formData.get("full_name"),
    birth_date: formattedDate,
    birth_time: document.querySelector('input[name="time-input"]').checked ? "" : formData.get("birth_time"),
    birth_place: searchBox.getAttribute("selected"),
    birth_lat: searchBox.getAttribute("lat"),
    birth_long: searchBox.getAttribute("lon"),
    user_email: formData.get("email"),
    user_number: formData.get("phone"),
    chart_type: formData.get("chart_type"),
    country_code: formData.get("country_code"),
    purpose: formData.get("purpose"),
    source_type: 'gems_web'
  });

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": apiKey,
    },
  };

  fetch(apiEndpoint + "?" + urlParams, requestOptions)
    .then((response) => response.json())
    .then((data) => {
      console.log(data?.result);
      renderProducts(data?.result);
    })
    .catch((error) => {
      console.log("Error:", error);
      document.getElementById("loader").style.display = "none";
    });
});

document.querySelector('input[name="time-input"]').addEventListener("change", () => {
  if (document.querySelector('input[name="time-input"]').checked) {
    document.querySelector("#birth_time").disabled = true;
    document.getElementById("hours").disabled = true;
    document.getElementById("minutes").disabled = true;
    document.getElementById("ampm").disabled = true;
    document.querySelector(".time-input-wrapper").classList.remove("active");
  } else {
    document.querySelector("#birth_time").disabled = false;
    document.getElementById("hours").disabled = false;
    document.getElementById("minutes").disabled = false;
    document.getElementById("ampm").disabled = false;
    document.querySelector(".time-input-wrapper").classList.add("active");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const hoursDropdown = document.getElementById("hours");
  const minutesDropdown = document.getElementById("minutes");
  const ampmDropdown = document.getElementById("ampm");
  const hiddenInput = document.getElementById("birth_time");

  function updateHiddenTime() {
    const hours = parseInt(hoursDropdown.value, 10);
    const minutes = minutesDropdown.value;
    const ampm = ampmDropdown.value;

    let hours24 = hours;
    if (ampm === "PM" && hours !== 12) {
      hours24 += 12;
    } else if (ampm === "AM" && hours === 12) {
      hours24 = 0;
    }
    const formattedHours = hours24.toString().padStart(2, "0");
    const time = `${formattedHours}:${minutes}`;
    console.log(time);
    hiddenInput.value = time;
  }

  hoursDropdown.addEventListener("change", updateHiddenTime);
  minutesDropdown.addEventListener("change", updateHiddenTime);
  ampmDropdown.addEventListener("change", updateHiddenTime);

  document.getElementById("phone").addEventListener("change", function (event) {
    const phoneInput = event.target;
    const errorMessage = document.getElementById("phone-error");

    phoneInput.value = phoneInput.value.replace(/\D/g, "");

    if (phoneInput.value.length > 12) {
      phoneInput.value = phoneInput.value.slice(0, 12);
    }

    if (phoneInput.value === "" || phoneInput.value.length < 10) {
      errorMessage.style.display = "block";
    } else {
      errorMessage.style.display = "none";
    }
  });

  const chartTypeElement = document.querySelector('[name="chart_type"]');
  if (chartTypeElement) {
    chartTypeElement.addEventListener("change", function () {
      const selectedValue = chartTypeElement.value;

      const birthLuckNote = document.getElementById("birth-luck-note");
      const purposeNote = document.getElementById("purpose-note");
      const purposeSelect = document.getElementById("purpose");
      const purposeLabel = document.getElementById("purposeLabel");

      if (selectedValue === "purpose") {
        birthLuckNote.style.display = "none";
        purposeNote.style.display = "block";
        purposeSelect.style.display = "block";
        purposeLabel.style.display = "block";
      } else {
        birthLuckNote.style.display = "block";
        purposeNote.style.display = "none";
        purposeSelect.style.display = "none";
        purposeLabel.style.display = "none";
      }
    });
  }
});